import React from 'react';

const ShareIcon = ({ width = '19', height = '19', fill = '#4F4C4D' }) => {
  return (
    <>
      <svg
        width={width}
        height={height}
        viewBox="0 0 16 18"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M13.3333 12.7229C12.6578 12.7229 12.0533 12.994 11.5911 13.4187L5.25333 9.66867C5.29778 9.46084 5.33333 9.25301 5.33333 9.03614C5.33333 8.81928 5.29778 8.61145 5.25333 8.40361L11.52 4.68976C12 5.14157 12.6311 5.42169 13.3333 5.42169C14.8089 5.42169 16 4.21084 16 2.71084C16 1.21084 14.8089 0 13.3333 0C11.8578 0 10.6667 1.21084 10.6667 2.71084C10.6667 2.92771 10.7022 3.13554 10.7467 3.34337L4.48 7.05723C4 6.60542 3.36889 6.3253 2.66667 6.3253C1.19111 6.3253 0 7.53614 0 9.03614C0 10.5361 1.19111 11.747 2.66667 11.747C3.36889 11.747 4 11.4669 4.48 11.0151L10.8089 14.7741C10.7644 14.9639 10.7378 15.1627 10.7378 15.3614C10.7378 16.8163 11.9022 18 13.3333 18C14.7644 18 15.9289 16.8163 15.9289 15.3614C15.9289 13.9066 14.7644 12.7229 13.3333 12.7229Z"
          fill={fill}
        />
      </svg>
    </>
  );
};

export default ShareIcon;
